import { render, staticRenderFns } from "./EmployeeEducationDetailForm.vue?vue&type=template&id=54c098c8&scoped=true&"
import script from "./EmployeeEducationDetailForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeEducationDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c098c8",
  null
  
)

export default component.exports